<template>
  <v-card  tile flat>
    <v-toolbar class="bg-transparent w-100-pct" absolute flat>
        <div class="fz-28-px font-weight-bold ft-color-main">{{ currGame['title_' + lang] }}</div>
        <v-spacer></v-spacer>
        <v-btn class="w-30-px mx-6-px my-4-px bg-main px-15-px" dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pt-60-px d-flex flex-column">
      <!-- {{ currGame }} -->
      <!-- <div class="d-flex align-center">
        <v-chip class="mr-16-px my-8-px pt-2-px opacity-1" label outlined small>{{ currGame.gametype }}</v-chip>
      </div>
      <div class="py-0-px font-weight-black ft-color-main">{{ currGame['title_' + lang] }}</div>
      <div class="fz-13-px text--secondary"> Type: {{ translate(currGame.type) }}</div> -->
      <div class="font-weight-black ft-color-main text-left">{{ $t('SUPPCURRENCY') }}</div>
      {{ filterCurrency() }}
      <div class="font-weight-black ft-color-main text-left">{{ $t('SUPPLANG') }}</div>
      {{ translateLanguageList(currGame.language) }}
      <div v-if="currGame.RTP" class="font-weight-black ft-color-main text-left mb-4-px">RTP : <span class="" dark>{{ currGame.RTP }}</span></div>
      <div class="font-weight-black ft-color-main text-left mb-4-px">{{ $t('MOBILESUPP') }} :
        <span>
          {{ $t('HSCREENSUPPORT')}} : {{ currGame.horizontal_screen_support }} ,
          {{ $t('VSCREENSUPPORT')}} : {{ currGame.direct_screen_support}}
        </span>
      </div>
      <div class="font-weight-black ft-color-main text-left mb-4-px">{{ $t('TRIA') }} :
        <span>{{ currGame.tryout ? 'O' : 'X'}}</span>
      </div>
      <div v-if="currGame.game_play" class="font-weight-black ft-color-main text-left mb-4-px">{{ $t('LINEWAY') }} :
        <span>{{ currGame.game_play }}</span>
      </div>
      <div v-if="currGame.pch5" class="font-weight-black ft-color-main text-left mb-4-px">
        PC_H5 : <span> {{ currGame.pch5 ? 'O' : 'X' }}</span>  H5 : <span> {{ currGame.h5 ? 'O' : 'X'}}</span>
      </div>
      <div v-if="currGame.release_date" class="font-weight-black ft-color-main text-left mb-4-px">{{ $t('LAUNCHDATE') }} :
        <span>{{ currGame.release_date }}</span>
      </div>
      <v-divider class="mx-8 mb-4-px" vertical></v-divider>
      <div>
      <v-chip class="mr-2 pill" small :color="currGame.jackpot ? 'secondary' : 'info'" dark>Jackpot</v-chip>
      <v-chip class="mr-2 pill" small :color="currGame.sw_support ? 'secondary': 'info'" dark>{{ $t('SUPPORTSW') }}</v-chip>
      <v-chip class="mr-2 pill" small :color="currGame.tryout ? 'secondary' : 'info'">{{ $t('TRIA') }}</v-chip>
      <v-chip class="mr-2 pill" small :color="currGame.is_free ? 'secondary' : 'info'">{{ $t('FREEGAME') }}</v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { supportLanguages } from '@/i18n.ts'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'GameDetail',
  inject: ['checkUrl', 'mapUrl'],
  data() {
    return {}
  },
  computed: {
    ...mapState('common', ['lang']),
    ...mapState('auth', ['isLogin', 'loginUser']),
    ...mapState('games', ['currGame', 'downloadKeys']),
    languageMap() {
      return supportLanguages[this.lang]
    }
  },
  mounted() {
    this.filterCurrency()
  },
  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('message', ['setSnackbar']),
    close() {
      this.ChangeDialog('')
    },
    filterCurrency() {
      const data = ['CNY', 'USD', 'JPY', 'KRW', 'THB', 'VND', 'MYR', 'IDR', 'EUR',
        'AUD', 'GBP', 'BRL', 'INR', 'MMK', 'CAD']
      const filtered = data.filter(key => this.currGame[key] === true)
      // console.log(filtered)
      return filtered.join(', ')
    },
    translateLanguageList(langStr) {
      // console.log(langStr)
      return langStr.split(',').map(lang => this.languageMap.languages[lang.trim()] || lang.trim()).join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>

.v-toolbar__content{
  padding: 4px 24px;
}

.theme--light.v-card span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.pill{
  color: #fff !important;
  margin-bottom: 4px;
}
</style>
